<!-- You can put <div class="origin"></div> inside any div to see the origin of the element (if correct in scss) -->
<div class="product" [class]="'product_' + icon()">
	@switch (icon()) {
		@case (Icons.KEY_SINGLE) {
			<div class="item shadow"></div>
			<div class="item key"></div>
		}
		@case (Icons.KEY_SET) {
			<div class="key-set">
				<div class="item key-ring"></div>
				<div class="item key key-1"></div>
				<div class="item key-ring key-ring-1"></div>
				<div class="item key key-2"></div>
				<div class="item key-ring key-ring-2"></div>
				<div class="item key key-3"></div>
				<div class="item key-ring key-ring-3"></div>
			</div>
		}
		@case (Icons.KEY_SET_HEAVY) {
			<div class="key-set-heavy">
				<div class="item key-ring"></div>
				<div class="item key key-1"></div>
				<div class="item key-ring key-ring-1"></div>
				<div class="item key key-2"></div>
				<div class="item key-ring key-ring-2"></div>
				<div class="item key key-3"></div>
				<div class="item key-ring key-ring-3"></div>
				<div class="item key key-4"></div>
				<div class="item key-ring key-ring-4"></div>
				<div class="item key key-5"></div>
				<div class="item key-ring key-ring-5"></div>
				<div class="item key key-6"></div>
				<div class="item key-ring key-ring-6"></div>
				<div class="item key key-7"></div>
				<div class="item key-ring key-ring-7"></div>
				<div class="item key key-8"></div>
				<div class="item key-ring key-ring-8"></div>
			</div>
		}
		@case (Icons.KEY_CHEST) {
			<div class="full-chest">
				<div class="item chest-lid"></div>
				<div class="item chest"></div>
				<div class="key-short-wrapper">
					<div class="item key-short"></div>
				</div>
			</div>
			<div class="item key-short key-short-1"></div>
			<div class="item key-short key-short-2"></div>
			<div class="item key-short key-short-3"></div>
		}
		@case (Icons.KEY_CHEST_MANY) {
			<div class="item sunlight"></div>
			<div class="full-chest full-chest-1">
				<div class="item chest-lid"></div>
				<div class="item chest"></div>
				<div class="key-short-wrapper">
					<div class="item key-short"></div>
				</div>
			</div>
			<div class="full-chest full-chest-2">
				<div class="item chest-lid"></div>
				<div class="item chest"></div>
				<div class="key-short-wrapper">
					<div class="item key-short"></div>
				</div>
			</div>
			<div class="item key-short key-short-1"></div>
			<div class="item key-short key-short-2"></div>
			<div class="item key-short key-short-3"></div>
			<div class="item key-short key-short-4"></div>
			<div class="item key-short key-short-5"></div>
		}
		@case (Icons.TICKET_SINGLE) {
			<div class="item shadow"></div>
			<div class="item ticket"></div>
		}
		@case (Icons.TICKET_SET) {
			<div class="item shadow shadow-1"></div>
			<div class="item shadow shadow-2"></div>
			<div class="item shadow shadow-3"></div>
			<div class="ticket-set">
				<div class="item ticket ticket-1"></div>
				<div class="item ticket ticket-2"></div>
				<div class="item ticket ticket-3"></div>
			</div>
		}
		@case (Icons.TICKET_STRIPS) {
			<div class="item shadow shadow-1"></div>
			<div class="item shadow shadow-2"></div>
			<div class="item ticket-strip ticket-strip-1">
				<div class="origin"></div>
			</div>
			<div class="item ticket-strip ticket-strip-2">
				<div class="origin"></div>
			</div>
		}
		@case (Icons.TICKET_REELS) {
			<div class="reel reel-1">
				<div class="item ticket-reel-strip"></div>
				<div class="item ticket-reel ticket-reel-b"></div>
			</div>
			<div class="item ticket ticket-1"></div>
			<div class="reel reel-2">
				<div class="item ticket-reel-strip"></div>
				<div class="item ticket-reel ticket-reel-a"></div>
			</div>
			<div class="item ticket ticket-2"></div>
			<div class="item ticket ticket-3"></div>
			<div class="item ticket ticket-4"></div>
		}
		@case (Icons.GIFT_N_KEY) {
			<div class="item gift"></div>
			<div class="item glow"></div>
			<div class="item key"></div>
		}
		@case (Icons.GIFT_N_TICKET) {
			<div class="item gift"></div>
			<div class="item glow"></div>
			<div class="item ticket"></div>
		}
		@case (Icons.PACK_BRONZE) {
			<div class="pack">
				<div class="item glow"></div>
				<div class="item gift"></div>
				<div class="item ticket ticket-1"></div>
				<div class="item ticket ticket-2"></div>
				<div class="item ticket ticket-3"></div>
				<div class="key-set">
					<div class="item key-ring"></div>
					<div class="item key key-1"></div>
					<div class="item key-ring key-ring-1"></div>
					<div class="item key key-2"></div>
					<div class="item key-ring key-ring-2"></div>
					<div class="item key key-3"></div>
					<div class="item key-ring key-ring-3"></div>
				</div>
			</div>
			<mos-pack-plate [label]="offer().packName" color="bronze"></mos-pack-plate>
		}
		@case (Icons.PACK_SILVER) {
			<div class="pack">
				<div class="item glow"></div>
				<div class="item gift"></div>
				<div class="item ticket ticket-1"></div>
				<div class="item ticket ticket-2"></div>
				<div class="item ticket ticket-3"></div>
				<div class="key-set">
					<div class="item key-ring"></div>
					<div class="item key key-1"></div>
					<div class="item key-ring key-ring-1"></div>
					<div class="item key key-2"></div>
					<div class="item key-ring key-ring-2"></div>
					<div class="item key key-3"></div>
					<div class="item key-ring key-ring-3"></div>
				</div>
			</div>
			<mos-pack-plate [label]="offer().packName" color="silver"></mos-pack-plate>
		}
		@case (Icons.PACK_GOLD) {
			<div class="pack">
				<div class="item glow"></div>
				<div class="item gift"></div>
				<div class="item ticket ticket-1"></div>
				<div class="item ticket ticket-2"></div>
				<div class="item ticket ticket-3"></div>
				<div class="key-set">
					<div class="item key-ring"></div>
					<div class="item key key-1"></div>
					<div class="item key-ring key-ring-1"></div>
					<div class="item key key-2"></div>
					<div class="item key-ring key-ring-2"></div>
					<div class="item key key-3"></div>
					<div class="item key-ring key-ring-3"></div>
				</div>
			</div>
			<mos-pack-plate [label]="offer().packName" color="gold"></mos-pack-plate>
		}
		@case (Icons.PACK_DIAMOND) {
			<div class="pack">
				<div class="item glow"></div>
				<div class="item gift"></div>
				<div class="item ticket ticket-1"></div>
				<div class="item ticket ticket-2"></div>
				<div class="item ticket ticket-3"></div>
				<div class="key-set">
					<div class="item key-ring"></div>
					<div class="item key key-1"></div>
					<div class="item key-ring key-ring-1"></div>
					<div class="item key key-2"></div>
					<div class="item key-ring key-ring-2"></div>
					<div class="item key key-3"></div>
					<div class="item key-ring key-ring-3"></div>
				</div>
			</div>
			<mos-pack-plate [label]="offer().packName" color="diamond"></mos-pack-plate>
		}
		@case (Icons.GIFT) {
			<div class="item shadow shadow-1"></div>
			<div class="item shadow shadow-2"></div>
			<div class="item shadow shadow-3"></div>
			<div class="item gift"></div>
		}

		@case (Icons.PACK_HALLOWEEN) {
			<div class="pack">
				<div class="item gift"></div>
				<div class="item ticket ticket-1"></div>
				<div class="item ticket ticket-2"></div>
				<div class="item ticket ticket-3"></div>
				<div class="key-set">
					<div class="item key-ring"></div>
					<div class="item key key-1"></div>
					<div class="item key-ring key-ring-1"></div>
					<div class="item key key-2"></div>
					<div class="item key-ring key-ring-2"></div>
					<div class="item key key-3"></div>
					<div class="item key-ring key-ring-3"></div>
				</div>
			</div>
			<div class="item halloween"></div>
		}

		@case (Icons.PACK_CHRISTMAS) {
			<div class="pack">
				<div class="item gift"></div>
				<div class="item ticket ticket-1"></div>
				<div class="item ticket ticket-2"></div>
				<div class="item ticket ticket-3"></div>
				<div class="key-set">
					<div class="item key-ring"></div>
					<div class="item key key-1"></div>
					<div class="item key-ring key-ring-1"></div>
					<div class="item key key-2"></div>
					<div class="item key-ring key-ring-2"></div>
					<div class="item key key-3"></div>
					<div class="item key-ring key-ring-3"></div>
				</div>
			</div>
			<div class="item christmas"></div>
		}

		@case (Icons.PACK_VALENTINES_DAY) {
			<div class="pack">
				<div class="item gift"></div>
				<div class="item ticket ticket-1"></div>
				<div class="item ticket ticket-2"></div>
				<div class="item ticket ticket-3"></div>
				<div class="key-set">
					<div class="item key-ring"></div>
					<div class="item key key-1"></div>
					<div class="item key-ring key-ring-1"></div>
					<div class="item key key-2"></div>
					<div class="item key-ring key-ring-2"></div>
					<div class="item key key-3"></div>
					<div class="item key-ring key-ring-3"></div>
				</div>
			</div>
			<div class="item valentines"></div>
		}
	}
	@if (
		!isMobileApp() &&
		[
			Icons.KEY_CHEST_MANY,
			Icons.TICKET_REELS,
			Icons.GIFT,
			Icons.GIFT_N_KEY,
			Icons.GIFT_N_TICKET,
			Icons.PACK_BRONZE,
			Icons.PACK_SILVER,
			Icons.PACK_GOLD,
		].includes($any(icon()))
	) {
		<mos-canvas-emitter [config]="emitter1Config" #emitter1 />
		<mos-canvas-emitter [config]="emitter2Config" #emitter2 />
	}
</div>
